import Paper from "@mui/material/Paper";
import { PROP_TYPES, DEFAULT_STATE } from "pages/order/prop-types";
import { StyledShipTo, WorkOrderHeading } from "styles/pages/order";
import {
  CONFLUENCE_VENDORS,
  CONFLUENCE_VENDORS_CLIENTS,
  CONFLUENCES_USERS,
  PRINT_PROVIDERS,
} from "constants/services";
import { useFetch } from "hooks/useFetch";
import Autocomplete from "components/Autocomplete";
import TagsAutocomplete from "components/TagsAutocomplete";
import TextField from "components/TextFieldInput";
import validateEmail from "utils/email-regex";

const SalesOrderOrderDetails = ({ state, setState }) => {
  const { data: vendors } = useFetch(CONFLUENCE_VENDORS, CONFLUENCE_VENDORS);

  const { data: printProviders } = useFetch(PRINT_PROVIDERS, PRINT_PROVIDERS);

  return (
    <Paper elevation={3}>
      <WorkOrderHeading>Order Details</WorkOrderHeading>
      <StyledShipTo>
        <div style={{ display: "flex", gap: 15, marginBottom: 25 }}>
          {/* <TextField
            label="Invoice #"
            value={state?.invoiceNumber}
            handleChange={(e) =>
              setState({
                ...state,
                invoiceNumber: invoiceNumber,
              })
            }
          /> */}

          <Autocomplete
            label="Customer Profiles"
            value={state?.vendorName}
            setValue={(c) => {
              setState({
                ...state,
                vendorName: c,
              });
            }}
            inputValue={state?.vendorNameInput}
            setInputValue={(v) =>
              setState({
                ...state,
                vendorNameInput: v,
              })
            }
            options={
              vendors?.map((u) => ({
                ...u,
                id: u?.name,
                label: u?.name,
              })) || []
            }
          />

          <Autocomplete
            label="Print Provider"
            value={state?.printProvider}
            setValue={(c) => {
              const defaultUsers = printProviders?.find(
                (p) => p?.printProvider === c?.id
              )?.defaultUsers;

              setState({
                ...state,
                printProvider: c,
                assigneeEmails: defaultUsers?.map((u) => ({
                  title: u,
                  value: u,
                })),
              });
            }}
            inputValue={state?.printProviderInput}
            setInputValue={(v) => setState({ ...state, printProviderInput: v })}
            // options={[{ id: "CA", label: "CA" }]}
            options={
              printProviders?.map((u) => ({
                id: u?.printProvider,
                label: u?.printProvider,
              })) || []
            }
          />
        </div>

        <div style={{ display: "flex", gap: 15 }}>
          {state?.vendorName?.id && (
            <TagsAutocomplete
              createable
              disabled={!state?.vendorName?.id}
              hardFetchOptions={!!state?.vendorName?.id}
              optionApiKey="clientEmail"
              apiEndPoint={`${CONFLUENCE_VENDORS_CLIENTS}/${state?.vendorName?.id}`}
              title="Add Client Email"
              subTitle="Add a new Customer"
              value={state?.clientEmails}
              setValue={(clientEmails) => setState({ ...state, clientEmails })}
              optionValidation={validateEmail}
              label="Client Email"
            />
          )}

          <TagsAutocomplete
            optionApiKey="email"
            apiEndPoint={CONFLUENCES_USERS}
            title="Add Assignee Email"
            subTitle="Add a new Assignee in this Customer"
            value={state?.assigneeEmails}
            setValue={(assigneeEmails) =>
              setState({ ...state, assigneeEmails })
            }
            optionValidation={validateEmail}
            label="Assignee Email"
          />

          <TextField
            label="Client Contact #"
            value={state?.clientContact}
            type="text"
            handleChange={(e) => {
              setState({
                ...state,
                clientContact: e?.target?.value,
              });
            }}
          />
        </div>
      </StyledShipTo>
    </Paper>
  );
};

SalesOrderOrderDetails.propTypes = PROP_TYPES;

SalesOrderOrderDetails.defaultProps = DEFAULT_STATE;

export default SalesOrderOrderDetails;
